import { createSlice } from "@reduxjs/toolkit";
import { save_tokens_constant, asyncStatus } from "../../utils/asyncStatus";
import { check_auth, login_service_auth } from "../../services/authentication";
import {
  success_toast_message,
  error_toast_message,
} from "../../utils/toast_message";
import {
  getAllStoresAsync,
  getStoreByIdAsync,
  updateStoreStatusAsync,
} from "../../services/StoreManagementServices";

const initialState = {
  // GET ALL STORES >>>>>>>>>>>>>
  get_all_stores_status: asyncStatus.IDLE,
  get_all_stores_data: null,
  get_all_stores_error: null,

  // GET STORE BY ID >>>>>>>>>>>>>
  get_store_by_id_status: asyncStatus.IDLE,
  get_store_by_id_data: null,
  get_store_by_id_error: null,

  // EDIT STORE >>>>>>>>>>>>>
  update_store_status_status: asyncStatus.IDLE,
  update_store_status_data: null,
  update_store_status_error: null,
};

const StoreManagementSlice = createSlice({
  name: "store_management",
  initialState,
  reducers: {
    setIdleStatus(state) {
      state.login_status = asyncStatus.IDLE;
    },
  },
  extraReducers: (builder) => {
    // GET ALL STORES >>>>>>>>>>>>>
    builder.addCase(getAllStoresAsync.pending, (state, action) => {
      state.get_all_stores_status = asyncStatus.LOADING;
    });

    builder.addCase(getAllStoresAsync.fulfilled, (state, { payload }) => {
      state.get_all_stores_status = asyncStatus.SUCCEEDED;
      state.get_all_stores_data = payload.data;
    });

    builder.addCase(getAllStoresAsync.rejected, (state, action) => {
      state.get_all_stores_status = asyncStatus.ERROR;
      state.get_all_stores_error = action.error;
      error_toast_message(action.error.message);
    });

    // GET STORE BY ID >>>>>>>>>>>>>
    builder.addCase(getStoreByIdAsync.pending, (state, action) => {
      state.get_store_by_id_status = asyncStatus.LOADING;
    });

    builder.addCase(getStoreByIdAsync.fulfilled, (state, { payload }) => {
      state.get_store_by_id_status = asyncStatus.SUCCEEDED;
      state.get_store_by_id_data = payload?.data;
    });

    builder.addCase(getStoreByIdAsync.rejected, (state, action) => {
      state.get_store_by_id_status = asyncStatus.ERROR;
      state.get_store_by_id_error = action.error;
      error_toast_message(action.error.message);
    });

    // EDIT STORE >>>>>>>>>>>>>
    builder.addCase(updateStoreStatusAsync.pending, (state, action) => {
      state.update_store_status_status = asyncStatus.LOADING;
    });

    builder.addCase(updateStoreStatusAsync.fulfilled, (state, { payload }) => {
      state.update_store_status_status = asyncStatus.SUCCEEDED;
      state.update_store_status_data = payload.data;
      success_toast_message("Store status updated successfully");
    });

    builder.addCase(updateStoreStatusAsync.rejected, (state, action) => {
      state.update_store_status_status = asyncStatus.ERROR;
      state.update_store_status_error = action.error;
      error_toast_message(action.error.message);
    });
  },
});

export const { setIdleStatus } = StoreManagementSlice.actions;

export default StoreManagementSlice.reducer;
